import React from 'react';

const VARIANT_CLASSES = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  danger: 'btn-danger',
  ghost:
    'bg-transparent hover:bg-secondary-100 text-secondary-600 dark:hover:bg-secondary-700 dark:text-secondary-300 font-medium py-2 px-3 rounded-lg transition-colors',
};

const Button = React.forwardRef(function Button(
  {
    variant = 'primary',
    type = 'button',
    className = '',
    disabled = false,
    children,
    ...rest
  },
  ref
) {
  const variantClass = VARIANT_CLASSES[variant] || VARIANT_CLASSES.primary;
  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled}
      className={`${variantClass} inline-flex items-center justify-center gap-1.5 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
});

export default Button;
